import { ProductName } from "../CurrentPlan/constants";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Member/Subscription/constants";
/**
 * 订阅组件常量定义文件
 */

const I18n = I18nUtil.createScoped(Translations);

// 账单周期类型定义
export const BillingCycle = {
  MONTH: "MONTH",
  YEAR: "YEAR",
  WEEK: "WEEK",
  LIFETIME: "LIFETIME",
} as const;

// 圣诞活动折扣值
export const DiscountValue = 40;
export const DiscountValueYearlyPrice = 360;

// 基础折扣值映射
export const DiscountValueMaps: Record<string, Record<string, number>> = {
  [ProductName.Pro]: {
    [BillingCycle.MONTH]: 32.99,
    [BillingCycle.YEAR]: 44.45,
  },
  [ProductName.Expert]: {
    [BillingCycle.MONTH]: 29.99,
    [BillingCycle.YEAR]: 41.67,
  },
} as const;

export const freeGetFeatures = (): {
  title: string;
  value: string;
  tip?: string;
}[] => [
  {
    title: I18n.t("Lifetime Credits"),
    value: "100",
  },
  // {
  //   title: I18n.t("CIO Level"),
  //   value: I18n.t("Basic"),
  // },
  {
    title: I18n.t("Portfolio Sync"),
    value: I18n.t("Manual Entry only"),
  },
  {
    title: I18n.t("Data Access"),
    value: I18n.t("Delayed / Standard data"),
  },
];

// Pro 套餐的权益数据（图片中显示的内容）
export const proGetFeatures = (): {
  title: string;
  value: string;
  tip?: string;
}[] => [
  {
    title: I18n.t("Monthly Credits"),
    value: "3000",
    // tip: I18n.t(
    //   "Enough for daily Smart Searches and ~10 Deep Reports per month.",
    // ),
  },
  {
    title: I18n.t("Portfolio Sync"),
    value: I18n.t("Unlimited Auto-Sync"),
  },
  {
    title: I18n.t("Data Access"),
    value: I18n.t("Real-time Smart Search"),
  },
  {
    title: I18n.t("Rollover"),
    value: I18n.t("Unused credits expire monthly"),
  },
  {
    title: I18n.t("AI Stock Picks"),
    value: I18n.t("Buy price, sell price, why"),
  },
  {
    title: I18n.t("Earnings Plays"),
    value: I18n.t("Pre-earnings signals"),
  },
  {
    title: I18n.t("IPO Strategies"),
    value: I18n.t("What to buy, which to skip"),
  },
];

// Expert 套餐的权益数据（图片中显示的内容）
export const expertGetFeatures = (): {
  title: string;
  value: string;
  tip?: string;
}[] => [
  {
    title: I18n.t("Monthly Credits"),
    value: "10,000",
    // tip: I18n.t(
    //   "Massive capacity for frequent 360° Reports and heavy data API usage.",
    // ),
  },
  {
    title: I18n.t("Portfolio Sync"),
    value: I18n.t("Unlimited + Export Capabilities"),
  },
  {
    title: I18n.t("Data Access"),
    value: I18n.t("Real-time + Institutional Depth"),
  },
  {
    title: I18n.t("Rollover"),
    value: I18n.t(
      "Included. Unused credits roll over to the next month automatically",
    ),
  },
  {
    title: I18n.t("AI Stock Picks"),
    value: I18n.t("Buy price, sell price, why"),
  },
  {
    title: I18n.t("Earnings Plays"),
    value: I18n.t("Pre-earnings signals"),
  },
  {
    title: I18n.t("IPO Strategies"),
    value: I18n.t("What to buy, which to skip"),
  },
];
